export default __webpack_public_path__ + "static/media/31.21f49876.jpg";